import './bootstrap'
import {sync, State} from "vuex-router-sync";
import GoogleSignInPlugin from "vue3-google-signin"
import vue3GoogleLogin from 'vue3-google-login'
import store from "./store";
import router from "./router";
import axios from "axios";

Vue.use(router)
Vue.use(store)

sync(store, router)
Vue.mount("#app")